<!--动态图对象 右键属性-->
<template>
  <div>
    <gs-modal v-loading="loading" v-model="visible" :before-close="beforeClose" :before-confirm="beforeConfirm"
      :title="isEdit ? name + '数据接口' : '新建' + '数据接口'" :has-form="true" class="my-test-class" @close="close"
      @confirm="handleConfirmTemp">
      <gs-tabs v-model="activeName" type="content-tab">
        <gs-tab-pane label="常规" name="first">
          <div class="top-form-right">
            <gs-form label-width="100px" label-position="left" gap="small">
              <gs-form-item label="名称" prop="target" class="form-item-radio">
                <gs-input ref="nameInput" v-model="nameData" />
              </gs-form-item>
              <gs-form-item label="描述" prop="target" class="form-item-radio">
                <gs-input ref="nameInput" v-model="description" />
              </gs-form-item>
              <gs-form-item label="接口属性">
                <el-radio-group v-model="resource">
                  <el-radio label="true">公共接口</el-radio>
                  <el-radio label="false">私有接口</el-radio>
                </el-radio-group>
              </gs-form-item>
              <!-- <gs-form-item
                label="结束时间"
                prop="stopTime"
              >
                <gs-date-picker
                  v-model="stopTime"
                  :default-time="defaultTime"
                  type="date-time"
                />
              </gs-form-item> -->
            </gs-form>
          </div>
          <div>
            <span>对象列表：</span>
            <div class="form-item-objectSeries">
              <gs-table v-if="visible" ref="objTable" :data="form.objectSeries" @select="selectData"
                @select-all="selectData">
                <gs-table-column type="selection" />
                <gs-table-column :show-overflow-tooltip="true" prop="name" label="名称" data-align="right" width="" />
                <gs-table-column :show-overflow-tooltip="true" prop="type" label="类型" width="" />
              </gs-table>
            </div>
            <div class="bottom-btn">
              <gs-button type="primary" @click="add">添加</gs-button>
              <gs-button type="primary" @click="del">删除</gs-button>
            </div>
          </div>
        </gs-tab-pane>
        <!-- <gs-tab-pane
          label="定时任务补偿"
          name="fourth"
        >定时任务补偿</gs-tab-pane> -->
      </gs-tabs>
      <span slot="footer" class="dialog-footer">
        <gs-button type="primary" size="mini" @click="handleConfirmTemp">确 定</gs-button>
        <gs-button type="primary" size="mini" @click="beforeClose">取 消</gs-button>
        <!--  <gs-button type="primary"  size="mini">帮 助</gs-button> -->
      </span>
    </gs-modal>
    <gs-modal v-model="visibleAdd" :before-close="beforeCloseAdd" class="my-test-class" title="添加" @close="closeAdd"
      @confirm="handleConfirmAdd">
      <gs-tree v-if="visibleAdd" ref="tree" :data="addList" :props="props" :disable-node="true" :node-key="'id'"
        show-checkbox :leaf-checkbox-only="true" @check-change="checkEvent">
      </gs-tree>
    </gs-modal>
    <gs-modal v-model="visibleProperties" :before-close="beforeCloseProperties" class="my-test-class" title="属性"
      @close="closeProperties" @confirm="handleConfirmProperties">
      <gs-select />
    </gs-modal>
    <gs-modal title="帮助" v-model="dialogHelp" class="my-test-class" width="42%">
      <!--<el-button @click="dialogHelp = false">取 消</el-button>
     <el-button type="primary" @click="dialogHelp = false">确 定</el-button>-->
    </gs-modal>
  </div>
</template>

<script type="text/ecmascript-6">
import { mapState, mapMutations } from "vuex";
import service from "../../service/leftService.js";
import moment from "moment";
import eventBus from "../timeChart/vue.js";
export default {
  components: {},
  data() {
    return {
      dialogHelp: false,
      min: 10,
      checkedLog: true,
      optionSpan: "Auto",
      logSpace_unit: "h",
      logSpace_value: 1,
      trendNum: 1,
      startTime: moment(),
      stopTime: moment(),
      defaultTime: moment(),
      objectInfo: {},
      loading: false,
      activeName: "first",
      form: {
        objectSeries: [],
        primaryY_autoScale: true,
        primaryY_Mininum: 0,
        primaryY_maximum: 100,
        secondaryY_autoScale: true,
        secondaryY_Mininum: 0,
        secondaryY_maximum: 100,
        logInterval_value: 1,
        logInterval_unit: "s",
        logInterval_active: "Auto",
        logSpace_value: 1,
        logSpace_unit: "s",
        // maxLogNum: ''
      },
      description: "",
      checked: "",
      options: [
        {
          label: "秒(s)",
          value: "s",
        },
        {
          label: "分(m)",
          value: "m",
        },
        {
          label: "时(h)",
          value: "h",
        },
        {
          label: "天(d)",
          value: "d",
        },
      ],
      active: [
        {
          label: "关闭",
          value: "Man-Off",
        },
        {
          label: "打开",
          value: "Man-On",
        },
        {
          label: "自动",
          value: "Auto",
        },
      ],
      visibleAdd: false,
      visibleProperties: false,
      addList: [],
      props: {
        label: "name",
        disabled: "type:folder",
      },
      selectList: [],
      name: "",
      showList: [],
      row: "",
      isEdit: false,
      oldData: {},
      nameData: "",
      subDevice: [],
      resource: 'true',
      original: [],
    };
  },
  computed: {
    ...mapState({
      visible: "dataInterfaceShow",
      nodeData: "objectInfo",
    }),
  },
  watch: {
    tableData() {
      this.form.objList = this.tableData;
    },
    nodeData() { },
    visible() {
      if (this.visible) {
        console.log(this.nodeData)
        this.objectInfo = JSON.parse(JSON.stringify(this.nodeData));
        if (
          JSON.stringify(this.objectInfo) !== "{}" &&
          this.objectInfo.type === "dataInterface"
        ) {
          this.isEdit = true;
          this.activeName = "first";
          this.description = this.objectInfo.description
            ? this.objectInfo.description
            : "";
          this.nameData = this.objectInfo.name ? this.objectInfo.name : "";
          this.form.objectSeries = this.objectInfo.attribute.original
            ? JSON.parse(JSON.stringify(this.objectInfo.attribute.original))
            : [];
        } else {
          this.isEdit = false;
          this.activeName = "first";
          this.form = {
            objectSeries: [],
            primaryY_autoScale: true,
            primaryY_Mininum: 0,
            primaryY_maximum: 100,
            secondaryY_autoScale: true,
            secondaryY_Mininum: 0,
            secondaryY_maximum: 100,
            logInterval_value: 10,
            logInterval_unit: "s",
            // maxLogNum: ''
          };
          this.description = "";
          this.nameData = "";
        }
      }
    },
  },
  created() { },
  mounted() { },
  methods: {
    ...mapMutations({
      close: "DATA_INTERFACE_HIDE",
      needReload: "DATA_INTERFACE_TREE",
    }),
    clearLog() {
      let id = this.nodeData.id;
      service
        .DeleteTrendLog(id)
        .then((res) => {
          this.$Message.success("删除成功");
        })
        .catch((err) => {
          console.info(err);
        });
    },
    caiyangChange() {
      if (this.form.logInterval_unit != "s") {
        this.form.logInterval_value = 1;
        this.min = 1;
      } else {
        this.form.logInterval_value = 10;
        this.min = 10;
      }
    },
    handleChange() {
      if (this.form.logInterval_unit != "s") {
        //  this.form.logInterval_value = 1
        this.min = 1;
      } else {
        this.form.logInterval_value = 10;
        this.min = 10;
      }
    },
    optionStart() {
      this.optionSpan = this.form.logInterval_active;
    },
    beforeClose() {
      this.subDevice = []
      this.close();
    },
    handleCloseHelp() {
      this.dialogHelp = false;
    },
    // cancel () {
    //   this.nodeData = this.oldData
    //   this.close()
    // },
    beforeConfirm(e, done) {
      if (this.nameData === null || this.nameData === "") {
        this.$Message.warning("名称不能为空!");
        return;
      }
      if (!this.form.primaryY_autoScale) {
        if (this.form.primaryY_Mininum >= this.form.primaryY_maximum) {
          this.$Message.warning("Y轴最小值必须小于最大值");
          return;
        }
      }
      if (!this.form.secondaryY_autoScale) {
        if (this.form.secondaryY_Mininum >= this.form.secondaryY_maximum) {
          this.$Message.warning("Y轴最小值必须小于最大值");
          return;
        }
      }
      // done(false)可以阻止modal关闭
      done();
    },
    handleConfirm() {
      let _this = this;
      this.loading = true;
      let arr = [];
      let backArr = JSON.parse(JSON.stringify(this.form.objectSeries));
      this.form.objectSeries.forEach((e) => {
        arr.push(e.id);
      });
      this.form.objectSeries = arr;
      if (this.objectInfo.id && this.objectInfo.type === "trendLog") {
        let param = {
          id: this.objectInfo.id,
          name: this.name,
          type: "trendLog",
          parentId: this.objectInfo.id,
          description: this.description,
          value: null,
          timeStamp: 1575857454,
          attribute: {
            showTrendLogValues: this.trendNum,
            logPoint: {
              id: arr[0],
              property: "value",
              unit: "",
              trendNum: this.trendNum,
            },
            circularLog: true,
            logInterval: {
              value: _this.form.logInterval_value,
              unit: _this.form.logInterval_unit,
            },
            logSpace: {
              value: _this.logSpace_value,
              unit: _this.logSpace_unit,
            },
            activate: _this.form.logInterval_active,
            startTime: this.startTime.valueOf(),
            stopTime: this.stopTime.valueOf(),
            /*startVariable:{
                id:"5dd75624d5bec94eaf7796f6"


             }*/
            //logPoint:this.form.objectSeries,
            /*startTime: this.startTime.valueOf(),
              stopTime: this.stopTime.valueOf(),
              logInterval_value:this.form.logInterval_value,
              logInterval_unit:this.form.logInterval_unit,*/
            //  maxLogNum:this.form.maxLogNum
          }, // this.form // 其他信息这里，键值对形式
        };
        service
          .renamePoint(param)
          .then((res) => {
            this.loading = false;
            this.$Message.success("修改成功");
            _this.objectInfo.attribute.objectSeries = backArr;
            this.close();
            this.objectInfo.name = this.name;
            res.attribute.objectSeries = backArr;
            this.$store.state.tabPanel = res;
            this.$store.state.updateTreeNode = res;
            this.description = "";
            this.name = "";
            // this.form = {
            //   objectSeries: []
            // }
            this.showList = [];
            // eventBus.$emit('changeInterval', res)
          })
          .catch((err) => {
            this.loading = false;
            this.form.objectSeries = backArr;
            this.$Message.error(err.message);
          });
      } else {
        let param = {
          name: this.name,
          type: "trendLog",
          parentId: this.objectInfo.id,
          description: this.description,
          value: null,
          timeStamp: 1575857454,
          attribute: {
            showTrendLogValues: this.trendNum,
            logPoint: {
              id: arr[0],
              property: "value",
              unit: "",
            },
            circularLog: true,
            logInterval: {
              value: _this.form.logInterval_value,
              unit: _this.form.logInterval_unit,
            },
            logSpace: {
              value: _this.logSpace_value,
              unit: _this.logSpace_unit,
            },
            activate: _this.form.logInterval_active,
            startTime: this.startTime.valueOf(),
            stopTime: this.stopTime.valueOf(),
            /*startVariable:{
                id:"5dd75624d5bec94eaf7796f6"


             }*/
            //logPoint:this.form.objectSeries,
            /*startTime: this.startTime.valueOf(),
              stopTime: this.stopTime.valueOf(),
              logInterval_value:this.form.logInterval_value,
              logInterval_unit:this.form.logInterval_unit,*/
            //  maxLogNum:this.form.maxLogNum
          }, // this.form // 其他信息这里，键值对形式
        };
        service
          .newAddPoint(param)
          .then((res) => {
            this.loading = false;
            this.$Message.success("添加成功");
            setTimeout(() => {
              res.attribute.objectSeries = backArr;
              _this.$store.state.addTreeNode = res;
            }, 0);
            this.close();
            this.description = "";
            this.name = "";
            // this.form = {
            //   objectSeries: []
            // }
            this.showList = [];
          })
          .catch((err) => {
            this.loading = false;
            this.form.objectSeries = backArr;
            this.$Message.error(err.message);
          });
      }
    },
    handleConfirmTemp() {
      let _this = this;
      this.original = this.form.objectSeries
      let tempArr = [];
      for (let i = 0; i < this.form.objectSeries.length; i++) {
        if (tempArr.indexOf(this.form.objectSeries[i].parentId) === -1) {
          _this.subDevice.push({
            'id': this.form.objectSeries[i].parentId,
            'points': [this.form.objectSeries[i].id]
          })
          tempArr.push(this.form.objectSeries[i].parentId)
        } else {
          for (let j = 0; j < _this.subDevice.length; j++) {
            if (_this.subDevice[j].id === this.form.objectSeries[i].parentId) {
              _this.subDevice[j].points.push(this.form.objectSeries[i].id)
              break;
            }
          }
        }
      }
      let data = {
        name: this.nameData,
        type: "dataInterface",
        parentId: this.objectInfo.id,
        //isPublic: true,
        description: this.description,
        attribute: {
          subDevice: this.subDevice,
          isPublic: this.resource,
          original: this.original
        },
      };
      service
        .newAddPoint(data)
        .then((res) => {
          this.loading = false;
          this.$Message.success("添加成功");
          setTimeout(() => {
            _this.$store.state.addTreeNode = res;
          }, 0);
          this.close();
          this.description = "";
          this.name = "";
          this.nameData = '';
          this.subDevice = [];
          // this.form = {
          //   objectSeries: []
          // }
          this.showList = [];
        })
        .catch((err) => {
          this.loading = false;
          this.$Message.error(err.message);
          this.nameData = '';
          this.subDevice = [];
        });
    },
    onChange(v) { },
    add() {
      let _this = this;
      this.visibleAdd = true;
      if (this.nodeData.type == "server") {
        /*  setTimeout(() => {
           _this.addList = this.$store.state.nodeAll;
         }, 2000) */
        service.getAllTree().then(res => {
          _this.addList = res;
        })
      }
      else if (this.nodeData.type == "logicalGroup") {
        service.getTree('', this.nodeData.id).then(res => {
          res[0].children.forEach(item => {
            service.getTree('Point', item.id).then(restree => {
              item.children = restree[0].children
            })
          })
          setTimeout(() => {
            _this.addList = res;
          }, 2000)

        })
      } else {
        let ids = ""
        this.isEdit ? ids = this.nodeData.parentId : ids = this.nodeData.id
        service.getTree("Point", ids).then((res) => {
          this.addList = res;
          if (
            _this.form.objectSeries !== null &&
            _this.form.objectSeries.length > 0
          ) {
            setTimeout(() => {
              _this.form.objectSeries.forEach((res) => {
                _this.$refs.tree.setChecked(res.id, true);
              });
            }, 0);
          }
        });
      }
    },
    del() {
      if (this.selectList === null || this.selectList.length === 0) {
        this.$Message.warning("请至少选择一项");
        return;
      }
      this.selectList.forEach((value, index, array) => {
        this.form.objectSeries = this.form.objectSeries.filter((e) => {
          return e.id !== value.id;
        });
      });
    },
    yAxis() { },
    property() {
      if (this.selectList.length !== 1) {
        this.$Message.warning("只能勾选一项");
        return;
      }
      this.visibleProperties = true;
    },
    beforeCloseAdd() {
      this.visibleAdd = false;
    },
    closeAdd() {
      this.visibleAdd = false;
    },
    handleConfirmAdd() {
      let _this = this;
      this.$refs.tree.getCheckedNodes(true).forEach((e) => {
        _this.form.objectSeries.push(e.data);
      });
      this.form.objectSeries = this.unique(this.form.objectSeries, "id");
      this.visibleAdd = false;
    },
    unique(arr, name) {
      var hash = {};
      return arr.reduce(function (item, next) {
        hash[next[name]] ? "" : (hash[next[name]] = true && item.push(next));
        return item;
      }, []);
    },
    beforeCloseProperties() {
      this.visibleProperties = false;
    },
    closeProperties() {
      this.visibleProperties = false;
    },
    handleConfirmProperties() {
      this.visibleProperties = false;
    },
    checkEvent(node, isSelect, halfSelect) {
      //   value_Analog,
      // value_Multistate,
      // value_Binary,
      // value_String,
      // BinaryInput,
      // BinaryOutput,
      // AnalogInput,
      // AnalogOutput
      switch (node.type) {
        case "value_Analog":
          break;
        case "device":
          break;
        case "value_Multistate":
          break;
        case "value_Binary":
          break;
        case "value_String":
          break;
        case "BinaryInput":
          break;
        case "BinaryOutput":
          break;
        case "AnalogInput":
          break;
        case "AnalogOutput":
          break;

        default:
          /*this.$Message.error('此节点为目录，无法被选择')
            this.$refs.tree.setChecked(node.id, false)*/
          break;
      }
    },
    selectData(selection, row) {
      this.selectList = selection;
    },
  },
};
</script>
<style scoped>
.fifty-width-box {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  /* Firefox */
  -webkit-box-sizing: border-box;
  /* Safari */
  width: 100%;
  float: left;
  margin-right: 13px;
}

fieldset {
  padding: 12px;
  border-radius: 5px;
  border: solid 2px #d9d9d9;
}

.bottom-btn {
  margin: 20px;
  text-align: center;
}

.form-item-objectSeries {
  height: 200px;
  overflow: auto;
  margin-bottom: 12px;
  padding: 12px;
  border: solid 1px #d9d9d9;
  border-radius: 1px;
}

.tab {
  font-size: 16px;
  font-weight: 800;
}

.tit {
  font-size: 14px;
  font-weight: 800;
  color: #5d5d5d;
}

.txt {
  font-size: 14px;
  color: #5d5d5d;
}
</style>



// WEBPACK FOOTER //
// src/components/notebook/dataInterface.vue